export default __webpack_public_path__ + "static/media/enzona.f153feba.png";